// const BundleAnalyzerPlugin = require('webpack-bundle-analyzer').BundleAnalyzerPlugin
module.exports = {
  pwa: {
    themeColor: '#ffd400',
    assetsVersion: '0.10.0',
    workboxOptions: {
      skipWaiting: true
    },
    msTileColor: '#ffd400',
    manifestOptions: {
      background_color: '#ffffff'
    }
  // },
  // configureWebpack: {
  //   plugins: [new BundleAnalyzerPlugin()]
  }
  // pluginOptions: {
  //   webpackBundleAnalyzer: {
  //     analyzerMode: 'static'
  //   }
  // }
}
